import React from "react";
import {Box, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {SatelliteAlt as DeviceIcon, DeviceUnknown as FirmwareIcon} from "@mui/icons-material";
import ContentBox from "./ContentBox";
import {EMPTY_UI} from "../../../../../../variables";

interface CheckinContentType {
    model?: string;
    mcuFirmwareVersion?: string;
    lpaFirmwareVersion?: string;
}

export interface CheckinContentProps {
    content: string;
}

export default function CheckinContent({content}: CheckinContentProps) {
    const {t} = useTranslation();
    const contentTyped = JSON.parse(content) as CheckinContentType;
    return (
        <Stack
            title={`${contentTyped.model || t("generic_device")}:  ${t("device_mcu")}=${
                contentTyped.mcuFirmwareVersion || EMPTY_UI
            } | ${t("device_lpa")}=${contentTyped.lpaFirmwareVersion || EMPTY_UI} `}
        >
            <Stack direction="row">
                <DeviceIcon fontSize="small" />
                <ContentBox>{contentTyped.model || EMPTY_UI}</ContentBox>
            </Stack>
            <Stack direction="row">
                <FirmwareIcon fontSize="small" />
                <ContentBox>{contentTyped.mcuFirmwareVersion || EMPTY_UI}</ContentBox>
                <Box sx={{margin: "0 5px"}}>|</Box>
                <ContentBox>{contentTyped.lpaFirmwareVersion || EMPTY_UI}</ContentBox>
            </Stack>
        </Stack>
    );
}
